import React, { useEffect, useState } from "react";

import { CiVideoOn } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { IoTimeOutline } from "react-icons/io5";
import { TbCashBanknote } from "react-icons/tb";
import { IoPlay } from "react-icons/io5";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import clsx from "clsx";

const Banner = ({ id, state: details }) => {
  let [state, setState] = useState({});
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/get_banner/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <>
      {isLoading && (
        <div className="flex justify-center items-center h-[97vh] overflow-y-hidden">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && state !== "Banner not found" && (
        <div
          className="h-[114vh] relative text-white flex justify-center items-center max-sm:px-2 "
          style={{
            backgroundImage: `url(${state?.image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover", // make image cover the container
            backgroundPosition: "center", // optional, centers the image
          }}>
          <div className="absolute inset-0 bg-black opacity-70 z-0"></div>
          <div className="max-w-2xl w-full flex justify-center flex-col z-20 relative items-center text-center max-sm:max-w-full max-sm:px-2">
            <h1 className="font-semibold text-[#FFED00] text-4xl max-sm:text-xl">
              {state?.course_name}{" "}
            </h1>
            <p className="tex-xl font-normal mt-4 max-sm:text-sm  !leading-7">
              {state?.banner_title}
            </p>
            <ul className="space-y-3 mt-8 rounded-md border-2 border-[#FFFFFF80] p-5  max-sm:text-sm ">
              <li className="flex items-center gap-4 max-sm:text-[0.8rem]">
                <CiVideoOn className=" text-3xl max-sm:text-2xl" /> Date:
                <span className="font-bold">
                  {" "}
                  {state?.from_date} | {state?.to_date}
                </span>
              </li>
              <li className="flex items-center gap-4 max-sm:text-[0.8rem]">
                <CiLocationOn className=" text-3xl max-sm:text-2xl" />
                Venue : <span className="font-bold">{state?.venue}</span>
              </li>
              <li className="flex items-center gap-4 max-sm:text-[0.8rem]">
                <IoTimeOutline className=" text-3xl max-sm:text-2xl" /> Course
                Timing :{" "}
                <span className="font-bold"> {state?.program_timing}</span>
              </li>
              <li className="flex items-center gap-4 max-sm:text-[0.8rem]">
                <TbCashBanknote className=" text-3xl max-sm:text-2xl" />
                Price:
                <span className="font-bold">Rs.{state.price}/- only</span>
              </li>
            </ul>
            {/* <DialogDemo> */}
            <button
              onClick={() => window.open(details.razor)}
              style={{ backgroundColor: details.color }}
              className={clsx(
                " animate-pulse flex gap-4 m-auto items-center px-6 py-3 rounded-md mt-7",
                details.color ? `!bg-[${details.color}]` : "bg-primary"
              )}>
              Start Learning <IoPlay />
            </button>
            {/* </DialogDemo> */}
          </div>
        </div>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default Banner;
